import artwork01 from './assets/images/artwork/01.jpg';
import artwork02 from './assets/images/artwork/02.jpg';
import artwork03 from './assets/images/artwork/03.jpg';
import artwork04 from './assets/images/artwork/04.jpg';
import artwork05 from './assets/images/artwork/05.jpg';
import artwork06 from './assets/images/artwork/06.jpg';
import artwork07 from './assets/images/artwork/07.jpg';
import artwork08 from './assets/images/artwork/08.jpg';
import artwork09 from './assets/images/artwork/09.jpg';
import artwork10 from './assets/images/artwork/10.jpg';
import artwork11 from './assets/images/artwork/11.jpg';

import audio01 from './assets/files/en/01.mp3';
import audio02 from './assets/files/en/02.mp3';
import audio03 from './assets/files/en/03.mp3';
import audio04 from './assets/files/en/04.mp3';
import audio05 from './assets/files/en/05.mp3';
import audio06 from './assets/files/en/06.mp3';
import audio07 from './assets/files/en/07.mp3';
import audio08 from './assets/files/en/08.mp3';
import audio09 from './assets/files/en/09.mp3';
import audio10 from './assets/files/en/10.mp3';
import audio11 from './assets/files/en/11.mp3';


const STORIES = [
  {
    title: '新填地街－ 2017',
    desc: '舊香港建築散落不同地方，油麻地、灣仔、九龍城⋯⋯ 除了著名的歷史地標受人追捧，大部分時候，它們就像遺珠，只間中待人抬頭發現後感嘆一下，就靜靜佇立等待被清拆。<br/><br/>他有一種發現這些遺珠的能力，總是在古舊美麗的建築消失之前把它們畫下。例如這幅《新填地街》，他站在馬路對角線望過去，它就像長方形一個盒；畫完這幅畫的 3 個月後，它就開始清拆了。<br/><br/>面對清拆急速的節奏，繪畫過程中他感覺自己是在與時間競賽，於是張伯樂進入了逆流的時空，畫他本來畫不了的皇后碼頭。<br/><br/>以下的作品故事，究竟是由誰的口中說出，其實已經沒有探究的必要。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork01,
    soundTrack: audio01,
    soundTrackEN: audio01
  },
  {
    title: '吳松街臨時熟食中心 － 2017',
    desc: '又是我喜歡的弧形唐樓，但這個又特別點 —— 當你看到樓上比地舖更突出，就代表其實它原始的模樣和面積只到地舖那個位置，上面多出來的都只是缺少空間的香港人僭建，從半空偷面積。<br/><br/>對畫畫來說，這樣的形態很容易畫錯透視手法。但我知道這裏曾經有過香港其中一個最漂亮的霓虹燈牌「信興酒樓」，更想挑戰這棟唐樓，為它在畫作的世界裏重新長出那個幾年前已拆的招牌。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork02,
    soundTrack: audio02,
    soundTrackEN: audio02
  },
  {
    title: '東京街30-34號 － 2018 、信興酒樓 － 2017',
    desc: '又是我喜歡的弧形唐樓，但這個又特別點 —— 當你看到樓上比地舖更突出，就代表其實它原始的模樣和面積只到地舖那個位置，上面多出來的都只是缺少空間的香港人僭建，從半空偷面積。<br/><br/>對畫畫來說，這樣的形態很容易畫錯透視手法。但我知道這裏曾經有過香港其中一個最漂亮的霓虹燈牌「信興酒樓」，更想挑戰這棟唐樓，為它在畫作的世界裏重新長出那個幾年前已拆的招牌。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork03,
    soundTrack: audio03,
    soundTrackEN: audio03
  },
  {
    title: '工業用品鐵皮檔 － 2017',
    desc: '這是位於油麻地廣東道的工業用品鐵皮檔。門口正中位置掛了一個門鈴，讓人搖一搖，告知裏面的鐵匠：有客了！<br/><br/>我經常看着這些老檔口，想像他們如何收檔，即使知道沒有可能會把這些沒動過幾年以上的這麼多凌亂的東西收起來。後期畫多很多 layer，就可以挑戰一下這些。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork04,
    soundTrack: audio04,
    soundTrackEN: audio04
  },
  {
    title: '藍屋 － 2015',
    desc: '《藍屋》這幅早期作品，對我來說意義甚大 —— 它是第一幅使用鋼筆的作品，見證了我畫法改變的轉捩點。<br/><br/>從前用墨水筆，如 HI-TEC-C 0.3，或用毛筆輕掃出青澀的陰影。可是，那支筆定了 0.3 粗細度，它畫出來的線就只會是 0.3。那時我開始用鋼筆，畫出有敏感度的筆觸，還開始嘗試點描，模仿素描有九級色差的黑白灰固，學習鑽研由填黑、排線、打抹、留白四種度數，提升至六種度數。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork05,
    soundTrack: audio05,
    soundTrackEN: audio05
  },
  {
    title: '九龍城公和荳品廠 － 2020',
    desc: '這是位於九龍城福佬村道67號，已結業的公和荳品廠支店。雖然不及北河街設於1958年的總店歷史悠久，它亦早於1960年便開業，而且不像總店經過翻新，它始終都是這個模樣。至今，它仍在同一位置，但被空置、被貼上許多告示及傳單，等待被收購了附近整條街的地產商清拆。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork06,
    soundTrack: audio06,
    soundTrackEN: audio06
  },
  {
    title: '美都餐室－ 2016',
    desc: '讀書時期經常經過美都餐室，但我一直沒有吃過，現在可算是油麻地的地標之一。隨著「樓上雅座」四字愈來愈少，坐在餐室裡面的客人會否知道餐室、茶餐廳與冰室，本是有着很大分別的呢？',
    descEN: '',
    subTitle: '',
    imageSrc: artwork07,
    soundTrack: audio07,
    soundTrackEN: audio07
  },
  {
    title: '灣仔  － 2016',
    desc: '我喜歡灣仔中匯大廈有紐約的感覺，圓角街角樓也越來越少見。它後來成為我跟韓國藝術家金政基的互動契機。<br/><br/>我們在安古蘭國際漫畫節上碰面，我送上這幅畫作的明信片作為見面禮，他便驚喜地說：「我都有畫這座建築物！」他的漫畫《Spy Games》故事背景地是香港，其中一格以跟我相似的角度畫了灣仔中匯大廈。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork08,
    soundTrack: audio08,
    soundTrackEN: audio08
  },
  {
    title: '北河街58號 － 2017',
    desc: '深水埗北河街的一棟唐樓建築，仍保留寬敞的騎樓、雕花扶手和斑駁乾脆的鐵窗框。看似同樣老舊的地舖大金龍藥材，其實只是在30多年前買下店面，比起唐樓本身的樓齡，這家藥材店就像它的孩子。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork09,
    soundTrack: audio09,
    soundTrackEN: audio09
  },
  {
    title: '旺角街市 －  2020',
    desc: '旺角街市人來人往，場景的深度給我一種感覺永遠不會停下的熱鬧，甚至灣仔那個户外街市的長度還不及它。我小時候都是跟家人到户外街市買菜，所以比起集團連鎖室內街市，這畫面來得更熟悉。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork10,
    soundTrack: audio10,
    soundTrackEN: audio10
  },
  {
    title: '新蒲崗 － 2016',
    desc: '在成為全職畫家之前，我曾經在新蒲崗工作 3、4年，發現這裏的高樓圍住唐樓，越圍越少，高和低、新和舊的界線明顯，令我想起跟這裏的清拆風格很不一樣的九龍城一帶，重建新樓像在區內竪起一枝枝香。',
    descEN: '',
    subTitle: '',
    imageSrc: artwork11,
    soundTrack: audio11,
    soundTrackEN: audio11
  }
];

export default STORIES;
